import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDirectorChair: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="director-chair, chair"><path d="M19.25 11.75H4.75V2.75H19.25V11.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M2.75 11.75H4.75L12 16.5L19.25 21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M21.25 11.75H19.25L12 16.5L4.75 21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconDirectorChair;
